// extracted by mini-css-extract-plugin
export default {"place":"RecommendationPlace_place__PuqNn","image":"RecommendationPlace_image__0vO2s","title":"RecommendationPlace_title__fWYb-","location":"RecommendationPlace_location__c81Tj"};